(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/draws/assets/javascripts/week.js') >= 0) return;  svs.modules.push('/components/numbergames/draws/assets/javascripts/week.js'); 
'use strict';

let productMapping;
if (svs.isServer) {
  const trinidadCore = require('trinidad-core').core;
  productMapping = trinidadCore.components.require('numbergames', 'product-mapping').productMapping;
} else {
  productMapping = svs.numbergames.productMapping;
}
const {
  getProductItsId,
  getAllNumericIds
} = productMapping;

class WeekDraws {
  constructor(_ref) {
    let {
      draws = [],
      validUntil,
      serverTime
    } = _ref;
    getAllNumericIds().forEach(numeric => {
      this[getProductItsId(numeric)] = {
        isOpen: false,
        openDraw: {},
        nextDraw: {},
        allDraws: []
      };
    });
    this.setDrawData({
      draws,
      validUntil,
      serverTime
    });
    if (!svs.isServer) {
      document.addEventListener('visibilitychange', () => {
        this.keepUpToDate();
      });
    }
  }

  isOpen(products) {
    if (!Array.isArray(products)) {
      products = [products];
    }
    return products.every(product => this.isProductOpen(product));
  }

  isProductOpen(product) {
    var _this$getProductItsId;
    return (_this$getProductItsId = this[getProductItsId(product)]) === null || _this$getProductItsId === void 0 ? void 0 : _this$getProductItsId.isOpen;
  }

  currentDrawNumber(product) {
    var _this$getProductItsId2, _this$getProductItsId3;
    return (_this$getProductItsId2 = this[getProductItsId(product)]) === null || _this$getProductItsId2 === void 0 ? void 0 : (_this$getProductItsId3 = _this$getProductItsId2.openDraw) === null || _this$getProductItsId3 === void 0 ? void 0 : _this$getProductItsId3.drawNumber;
  }

  nextDrawNumber(product) {
    var _this$getProductItsId4, _this$getProductItsId5;
    return (_this$getProductItsId4 = this[getProductItsId(product)]) === null || _this$getProductItsId4 === void 0 ? void 0 : (_this$getProductItsId5 = _this$getProductItsId4.nextDraw) === null || _this$getProductItsId5 === void 0 ? void 0 : _this$getProductItsId5.drawNumber;
  }

  drawNumber(product) {
    return this.currentDrawNumber(product) || this.nextDrawNumber(product);
  }

  currentRegCloseTime(product) {
    var _this$getProductItsId6, _this$getProductItsId7;
    return (_this$getProductItsId6 = this[getProductItsId(product)]) === null || _this$getProductItsId6 === void 0 ? void 0 : (_this$getProductItsId7 = _this$getProductItsId6.openDraw) === null || _this$getProductItsId7 === void 0 ? void 0 : _this$getProductItsId7.regCloseTime;
  }

  nextRegCloseTime(product) {
    var _this$getProductItsId8, _this$getProductItsId9;
    return (_this$getProductItsId8 = this[getProductItsId(product)]) === null || _this$getProductItsId8 === void 0 ? void 0 : (_this$getProductItsId9 = _this$getProductItsId8.nextDraw) === null || _this$getProductItsId9 === void 0 ? void 0 : _this$getProductItsId9.regCloseTime;
  }

  regCloseTime(product) {
    return this.currentRegCloseTime(product) || this.nextRegCloseTime(product);
  }

  currentRegOpenTime(product) {
    var _this$getProductItsId10, _this$getProductItsId11;
    return (_this$getProductItsId10 = this[getProductItsId(product)]) === null || _this$getProductItsId10 === void 0 ? void 0 : (_this$getProductItsId11 = _this$getProductItsId10.openDraw) === null || _this$getProductItsId11 === void 0 ? void 0 : _this$getProductItsId11.regOpenTime;
  }

  nextRegOpenTime(product) {
    var _this$getProductItsId12, _this$getProductItsId13;
    return (_this$getProductItsId12 = this[getProductItsId(product)]) === null || _this$getProductItsId12 === void 0 ? void 0 : (_this$getProductItsId13 = _this$getProductItsId12.nextDraw) === null || _this$getProductItsId13 === void 0 ? void 0 : _this$getProductItsId13.regOpenTime;
  }

  regOpenTime(product) {
    return this.currentRegOpenTime(product) || this.nextRegOpenTime(product);
  }

  wasOpenedToday(product) {
    return dateFns.isToday(dateFns.parseISO(this.currentRegOpenTime(product)));
  }
  firstRegCloseProductOf(products) {
    let firstRegCloseTime;
    let firstProduct;
    products.forEach(product => {
      const regCloseTime = dateFns.parseISO(this.regCloseTime(product));
      if (!firstRegCloseTime || dateFns.isBefore(regCloseTime, firstRegCloseTime)) {
        firstRegCloseTime = regCloseTime;
        firstProduct = product;
      }
    });
    return firstProduct;
  }
  setDrawData(_ref2) {
    let {
      draws,
      validUntil,
      serverTime,
      updated
    } = _ref2;
    const offsetSec = dateFns.differenceInSeconds(Date.now(), dateFns.parseISO(serverTime));
    this.clientTimeOffset = Math.abs(offsetSec) > 30 ? offsetSec * 1000 : 0;
    this.validUntil = validUntil;
    this.keepUpToDate();
    const products = [];
    const weekDraws = {};
    draws.forEach(draw => {
      if (!weekDraws[draw.productItsId]) {
        products.push(draw.productItsId);
        weekDraws[draw.productItsId] = {
          isOpen: false,
          openDraw: {},
          nextDraw: {},
          allDraws: []
        };
      }
      weekDraws[draw.productItsId].allDraws.push(draw);
      if (draw.drawStateId === 2) {
        weekDraws[draw.productItsId].isOpen = true;
        weekDraws[draw.productItsId].openDraw = draw;
      } else {
        const nextDrawNumber = weekDraws[draw.productItsId].nextDraw.drawNumber;
        if (!nextDrawNumber || draw.drawNumber < nextDrawNumber) {
          weekDraws[draw.productItsId].nextDraw = draw;
        }
      }
    });
    products.forEach(productItsId => {
      this[productItsId] = weekDraws[productItsId];
    });
    this.products = products;
    if (updated) {
      svs.events.publish('/ng/draws/week/updated', {
        products,
        weekDraws
      });
    }
  }

  getDraws(products) {
    const matchToDraw = products.filter(_ref3 => {
      let {
        sameRegCloseDayAs
      } = _ref3;
      return sameRegCloseDayAs;
    });
    products = products.filter(_ref4 => {
      let {
        sameRegCloseDayAs
      } = _ref4;
      return !sameRegCloseDayAs;
    });
    const selectedDraws = products.map(_ref5 => {
      let {
        product,
        days
      } = _ref5;
      let {
        allDraws
      } = this[getProductItsId(product)];
      if (days) {
        allDraws = allDraws.filter(draw => days.includes(new Date(draw.regCloseTime).getDay()));
      }
      let firstDraw;
      let firstRegCloseTime;
      allDraws.forEach(draw => {
        const regCloseTime = dateFns.parseISO(draw.regCloseTime);
        if (!firstRegCloseTime || dateFns.isBefore(regCloseTime, firstRegCloseTime)) {
          firstRegCloseTime = regCloseTime;
          firstDraw = draw;
        }
      });
      return firstDraw;
    })
    .filter(draw => draw);
    matchToDraw.forEach(_ref6 => {
      let {
        product,
        sameRegCloseDayAs
      } = _ref6;
      const drawToMatch = selectedDraws.find(draw => draw.productItsId === sameRegCloseDayAs);
      if (drawToMatch) {
        const dateToMatch = new Date(drawToMatch.regCloseTime);
        const matchedDraw = this[getProductItsId(product)].allDraws.find(draw => dateFns.isSameDay(new Date(draw.regCloseTime), dateToMatch));
        if (matchedDraw) {
          selectedDraws.push(matchedDraw);
        }
      }
    });
    selectedDraws.sort((a, b) => new Date(a.regCloseTime).getTime() - new Date(b.regCloseTime).getTime());
    return selectedDraws;
  }
  get clientNow() {
    return Date.now() - this.clientTimeOffset;
  }
  keepUpToDate() {
    if (!svs.isServer) {
      const clientTtl = dateFns.differenceInMilliseconds(dateFns.parseISO(this.validUntil), this.clientNow);
      clearTimeout(this.updateTimeout);
      if (document.visibilityState !== 'hidden') {
        if (clientTtl > 0) {
          this.updateTimeout = setTimeout(() => this.updateDrawData(), clientTtl);
        } else {
          this.updateDrawData();
        }
      }
    }
  }
  updateDrawData() {
    var _svs$numbergames, _svs$numbergames$draw, _svs$numbergames$draw2;
    if ((_svs$numbergames = svs.numbergames) !== null && _svs$numbergames !== void 0 && (_svs$numbergames$draw = _svs$numbergames.draws_api) !== null && _svs$numbergames$draw !== void 0 && (_svs$numbergames$draw2 = _svs$numbergames$draw.data) !== null && _svs$numbergames$draw2 !== void 0 && _svs$numbergames$draw2.week) {
      delete svs.numbergames.draws_api.data.week;
    }
    svs.core.module.load('/cl/numbergames/draws-api?json=true&apiId=week', null, () => {
      var _svs$numbergames$draw3, _svs$numbergames2, _svs$numbergames2$dra, _svs$numbergames2$dra2;
      const {
        draws,
        validUntil,
        serverTime
      } = (_svs$numbergames$draw3 = (_svs$numbergames2 = svs.numbergames) === null || _svs$numbergames2 === void 0 ? void 0 : (_svs$numbergames2$dra = _svs$numbergames2.draws_api) === null || _svs$numbergames2$dra === void 0 ? void 0 : (_svs$numbergames2$dra2 = _svs$numbergames2$dra.data) === null || _svs$numbergames2$dra2 === void 0 ? void 0 : _svs$numbergames2$dra2.week) !== null && _svs$numbergames$draw3 !== void 0 ? _svs$numbergames$draw3 : {};
      this.setDrawData({
        draws,
        validUntil,
        serverTime,
        updated: true
      });
    }, null, false, true);
  }
}
if (svs.isServer) {
  module.exports = {
    getWeekDraws: _ref7 => {
      let {
        draws
      } = _ref7;
      return new WeekDraws({
        draws
      });
    }
  };
} else {
  let weekDraws;
  svs.numbergames.draws = svs.numbergames.draws || {};

  svs.numbergames.draws.setupWeekDraws = () => {
    if (!weekDraws) {
      var _svs$numbergames$draw4, _svs$numbergames$draw5;
      if ((_svs$numbergames$draw4 = svs.numbergames.draws_api) !== null && _svs$numbergames$draw4 !== void 0 && (_svs$numbergames$draw5 = _svs$numbergames$draw4.data) !== null && _svs$numbergames$draw5 !== void 0 && _svs$numbergames$draw5.week) {
        const {
          draws,
          validUntil,
          serverTime
        } = svs.numbergames.draws_api.data.week;
        weekDraws = new WeekDraws({
          draws,
          validUntil,
          serverTime
        });
      }
    }
  };
  svs.numbergames.draws.setupWeekDraws();
  svs.numbergames.draws.getWeekDraws = () => weekDraws;
}
 })(window);